var showmore_buttons = document.getElementsByClassName('accordion__show-more');
var contents = document.getElementsByClassName('accordion__content');
for(let i = 0; i < contents.length; i++) {
    contents[i].setAttribute('aria-hidden', true);
}
for (let i = 0; i < showmore_buttons.length; i++) {
    
    showmore_buttons[i].addEventListener("click", function(){    
        var parent = showmore_buttons[i].parentElement;
        var content = parent.parentElement.getElementsByClassName('accordion__content')[0];
        if (showmore_buttons[i].getAttribute('aria-hidden') === 'true') {
            showmore_buttons[i].setAttribute('aria-hidden', false);
            content.setAttribute('aria-hidden', false);
        } else {
            showmore_buttons[i].setAttribute('aria-hidden', true);
            content.setAttribute('aria-hidden', true);
        }
    });
}